import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { ManifestProvider } from './context/ManifestContext';
import { McpRegistryProvider } from './context/McpRegistryContext';
import Layout from './components/Layout';
import MarketplacePage from './pages/MarketplacePage';
import SkillDetailPage from './pages/SkillDetailPage';
import McpDetailPage from './pages/McpDetailPage';
import CreateSkillPage from './pages/CreateSkillPage';
import './App.css';
import { StylesProvider, ToastProvider } from '@caos/ca-component-library';

function App() {
  return (
    <StylesProvider>
      <ToastProvider position="bottom-right" defaultDuration={3000}>
        <BrowserRouter>
          <ManifestProvider>
            <McpRegistryProvider>
              <Layout>
                <Routes>
                  <Route path="/" element={<MarketplacePage />} />
                  <Route path="/skills/:id" element={<SkillDetailPage />} />
                  <Route path="/mcp/:id" element={<McpDetailPage />} />
                  <Route path="/create-skill" element={<CreateSkillPage />} />
                </Routes>
              </Layout>
            </McpRegistryProvider>
          </ManifestProvider>
        </BrowserRouter>
      </ToastProvider>
    </StylesProvider>
  );
}

export default App;
